import React from "react";

export function Section({ children, className = "", id, dataTestId }) {
  return (
    <section id={id} data-testid={dataTestId} className={`max-w-7xl mx-auto px-5 md:px-8 lg:px-12 ${className}`}>
      {children}
    </section>
  );
}

export function Overline({ children, className = "" }) {
  return <div className={`overline ${className}`}>{children}</div>;
}

export function H1({ children, className = "", ...rest }) {
  return <h1 className={`font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-medium text-white ${className}`} {...rest}>{children}</h1>;
}

export function H2({ children, className = "" }) {
  return <h2 className={`font-display text-3xl sm:text-4xl tracking-tight font-medium text-white ${className}`}>{children}</h2>;
}

export function Lead({ children, className = "" }) {
  return <p className={`text-base sm:text-lg text-neutral-300 leading-relaxed ${className}`}>{children}</p>;
}

export function Card({ children, className = "", dataTestId }) {
  return <div data-testid={dataTestId} className={`card-frame p-7 md:p-8 ${className}`}>{children}</div>;
}
